import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaTruck,
  FaBus,
  FaShuttleVan,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import HeroSection from "../heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import TestimonialsSection from "../testimonialsSection/TestimonialsSection";
import { useTranslation } from "react-i18next";

const Koeriersvoertuigen = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <div className="about-section">
        <Container fluid className="px-md-5">
          <section className="text-center transport-icons-section" data-aos="fade-up">
            <h4 className="text-orange mb-4">{t("Koeriersvoertuigen.title")}</h4>
            <p className="text-muted">
              <small>{t("Koeriersvoertuigen.description")}</small>
            </p>

            <div className="d-flex flex-wrap justify-content-center gap-4 mt-3">
              <div className="transport-icon-box" data-aos="fade-up">
                <div className="icon-circle mb-3">
                  <FaTruck size={30} />
                </div>
                <h6 className="mb-0 text-orange">{t("Koeriersvoertuigen.vehicles.0.name")}</h6>
                <p className="mb-0 text-muted">{t("Koeriersvoertuigen.vehicles.0.pallets")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.0.weight")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.0.dimensions")}</p>
              </div>
              <div className="transport-icon-box" data-aos="fade-up" data-aos-delay="100">
                <div className="icon-circle mb-3">
                  <FaBus size={30} />
                </div>
                <h6 className="mb-0 text-orange">{t("Koeriersvoertuigen.vehicles.1.name")}</h6>
                <p className="mb-0 text-muted">{t("Koeriersvoertuigen.vehicles.1.pallets")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.1.weight")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.1.dimensions")}</p>
              </div>
              <div className="transport-icon-box" data-aos="fade-up" data-aos-delay="200">
                <div className="icon-circle mb-3">
                  <FaShuttleVan size={30} />
                </div>
                <h6 className="mb-0 text-orange">{t("Koeriersvoertuigen.vehicles.2.name")}</h6>
                <p className="mb-0 text-muted">{t("Koeriersvoertuigen.vehicles.2.pallets")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.2.weight")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.2.dimensions")}</p>
              </div>
              <div className="transport-icon-box" data-aos="fade-up" data-aos-delay="300">
                <div className="icon-circle mb-3">
                  <FaTruck size={30} />
                </div>
                <h6 className="mb-0 text-orange">{t("Koeriersvoertuigen.vehicles.3.name")}</h6>
                <p className="mb-0 text-muted">{t("Koeriersvoertuigen.vehicles.3.pallets")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.3.weight")}</p>
                <p className="mb-0">{t("Koeriersvoertuigen.vehicles.3.dimensions")}</p>
              </div>
            </div>
          </section>
        </Container>
      </div>
    </>
  );
};

export default Koeriersvoertuigen;